import React from "react";
import "./styles.scss";
import { LoginForm } from "../../schoolUiComponents/loginForm";
import { useAuthSigninState } from "../state";

export const CommonLogin = ({isParent=false}) => {
    const { sendEvent } = useAuthSigninState();

    const label = isParent ? "Parents" : "Teacher";
    const url = isParent ? "/parents/register" : "/teachers/register";

    return (
        <div className="username-login">
            <h4>{label} Login</h4>
            <LoginForm primaryInputLabel="Username / Email" source={`${label} Login`} sendEvent={sendEvent}/>
            <div className="register-link">
                New {label} ?
                <a
                href={url}
                onClick={() => sendEvent(`Register here: ${url}`)} 
                >
                Register here
                </a>
            </div>
        </div>
    );
};